import { number, object, string } from "yup";

export const completeBookkeepingValidation = object({
  accounting_method: string().required("Accounting method is required"),
  from_date: string().required("Start date is required"),
  to_date: string().required("End date is required"),
  no_of_transactions: number().required("Number of transactions is required"),
  cash_expense: number().when("accounting_method", {
    is: "accrual",
    then: number().required("Cash expense is required"),
    otherwise: number().notRequired(),
  }),
  intra_group_transfers: string().when("accounting_method", {
    is: "accrual",
    then: string().required("Intra-group transfers is required"),
    otherwise: string().notRequired(),
  }),
  intra_company_transfers: string().when("accounting_method", {
    is: "accrual",
    then: string().required("Intra-company transfers is required"),
    otherwise: string().notRequired(),
  }),
});
